<div class="main-content" (window:resize)="onResize($event)">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card m_h_card">

                    <ng-container *ngIf="loading">
                        <div class="loading text-center">
                            <br />
                            <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                            <br />
                            <p>Loading assessments, please wait...</p>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!loading">
                        <div class="header">
                            <h4 class="title"></h4>
                            <p class="category"></p>
                        </div>

                        <div class="text-right">
                            <i [routerLink]="['/app/new360']" class="material-icons">add</i>
                        </div>
                        <div class="container-fluid">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #agGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="true"
                                                 [gridOptions]="gridOptions"
                                                 [rowData]="assessments"
                                                 [columnDefs]="assessmentsHeaders"
                                                 [enableSorting]="true"
                                                 [enableColResize]="true"
                                                 (rowClicked)="onRowClicked($event)"
                                                 (gridReady)="onGridReady($event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate">
                                </ag-grid-angular>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
